import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { MedicalRecord } from '../models/medical-record.model';
import { environment } from '../../environments/environment';

@Injectable({ providedIn: 'root' })
export class MedicalRecordService {
  private apiUrl = environment.APP_BASE_URL + '/doctor-portal/booking-view/appointment';

  constructor(private http: HttpClient) {}

  createConsultationMedicalRecord(
    patientId: string,
    record: MedicalRecord,
    doctorId?: string,
  ): Observable<MedicalRecord> {
    const params: Record<string, string> = {};
    if (doctorId) {
      params['doctorId'] = doctorId;
    }
    return this.http.post<MedicalRecord>(
      `${this.apiUrl}/consultation/${patientId}/medical-record`,
      record,
      { params },
    );
  }
}
